const serviceData = [
  {
    icon: "ri-truck-line",
    title: "Free Shipping",
    subtitle: "Enjoy free delivery on all furniture orders.",
    bg: "#fdefe6",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    subtitle: "Experience stress-free returns.",
    bg: "#ceebe9",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Secure Payment",
    subtitle: "Shop with confidence knowing that you're safe.",
    bg: "#e2f2b2",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: "Money Back Guaranteed",
    subtitle: "Not Satisfied? Free refunds.",
    bg: "#d6e5fb",
  },
];

export default serviceData;
